import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=20ae2e22&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.scss?vue&type=style&index=0&id=20ae2e22&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae2e22",
  null
  
)

export default component.exports